import type { SVGProps } from 'react'
const SvgSyLightning = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m9.556 13.323-.12-.01c-1.528-.14-2.292-.209-2.535-.732-.242-.522.198-1.15 1.077-2.407l3.583-5.119c.581-.83.872-1.245 1.123-1.157.25.089.217.594.15 1.605l-.204 3.049c-.062.92-.092 1.38.172 1.69.265.31.724.351 1.642.435l.12.01c1.528.14 2.292.209 2.534.732.243.522-.197 1.15-1.077 2.407l-3.582 5.119c-.581.83-.872 1.245-1.123 1.157s-.217-.594-.15-1.605l.204-3.049c.061-.92.092-1.38-.172-1.69-.265-.31-.724-.351-1.642-.435" />
		<path
			fillOpacity={0.24}
			d="M18.8 3.6a.5.5 0 0 0-.7.1l-1.5 2a.5.5 0 0 0 .4.8h1l-.9 1.2a.5.5 0 0 0 .1.7.5.5 0 0 0 .7-.1l1.5-2a.5.5 0 0 0-.4-.8h-1l.9-1.2a.5.5 0 0 0-.1-.7M6.43 15.506a.5.5 0 0 0-.33.193l-1.5 2a.5.5 0 0 0 .4.801h1l-.9 1.2a.5.5 0 0 0 .1.7.5.5 0 0 0 .7-.1l1.5-2a.5.5 0 0 0-.4-.8H6l.9-1.2a.5.5 0 0 0-.1-.7.5.5 0 0 0-.37-.094"
		/>
	</svg>
)
export default SvgSyLightning
